import React from 'react';
import { getCountryCodeFromPhone, getFlagIcon } from '../../../services/countryService';
import IconMC from '../../components/IconMC';

/**
 * CustomerInfoCard Component
 *
 * Reusable component that displays customer information in a card format.
 * Used by both CallConfirmationMC and RequestPermissionMC components.
 *
 * @param {Object} props - Component props
 * @param {Object} props.client - The client object containing customer information
 */
const CustomerInfoCard = ({ client }) => {
  const countryCode = getCountryCodeFromPhone(
    client.phone_with_country_code,
    client.phone
  );

  return (
    <div className="tw-w-full tw-bg-gray-50 tw-rounded-lg tw-p-8 tw-flex tw-flex-col tw-items-center">
      <div className="tw-mb-4 tw-w-16 tw-h-16 tw-rounded-full tw-bg-white tw-flex tw-items-center tw-justify-center tw-shadow-md">
        <IconMC name="person-fill" className="tw-w-8 tw-h-8 tw-text-blue-500" />
      </div>

      <h3 className="tw-text-base tw-font-semibold tw-text-gray-900 tw-text-center tw-mb-1">
        {client.name || `${client.first_name} ${client.last_name}`}
      </h3>

      {client.email && (
        <p className="tw-text-xs tw-text-gray-600 tw-mb-1">
          {client.email}
        </p>
      )}

      <div className="tw-flex tw-items-center tw-gap-1">
        {countryCode && getFlagIcon(countryCode)}
        <span className="tw-text-xs tw-text-gray-600">
          {client.phone_with_country_code || client.phone}
        </span>
      </div>
    </div>
  );
};

export default CustomerInfoCard;
